import { render, staticRenderFns } from "./ConsolidatedViewPage.vue?vue&type=template&id=1cc73960"
import script from "./ConsolidatedViewPage.vue?vue&type=script&lang=js"
export * from "./ConsolidatedViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports